import {
  GetStoriesAlgoliaDocument,
  GetStoriesAlgoliaQuery,
  GetStoriesAlgoliaQueryVariables,
} from 'generated/graphql';
import { client } from 'lib/graphql/client';
import { populateLocals } from '../utils/populateLocals';

export async function getStoriesAlgolia(
  paginatedResults: any[] = [],
  first: number = 999,
  after?: string | null | undefined,
): Promise<any> {
  if (first > 1000) throw new Error('first must be less than 1000');
  const initialValue = await client.query<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>({
    query: GetStoriesAlgoliaDocument,
    variables: {
      first: first,
      after: after,
    },
  });

  if (initialValue?.data?.storiesConnection?.pageInfo?.hasNextPage) {
    paginatedResults.push(...initialValue.data.storiesConnection.edges);
    return getStoriesAlgolia(
      paginatedResults,
      first,
      initialValue.data.storiesConnection.pageInfo.endCursor,
    );
  } else {
    paginatedResults.unshift(...initialValue.data.storiesConnection.edges);
  }

  return populateLocals(paginatedResults);
}
